import { dialog } from "../../../../../nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../../usecases/object";
import DialogModal from "../../../../../components/Dialog";

class WasteProductFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // async save() {
  //   const collection = this.view.getCollectionName();
  //   const user = this.view.getCurrentUser();
  //   const storeId = user?.storeAnalytic?.[0]?.id;

  //   // Base fields for every record
  //   const base = {};

  //   if (this.object?.id) {
  //     // If editing a single record mode
  //     base.id = this.object.id;
  //   } else {
  //     base.acl = this.view.getAcl();
  //     base.storeId = { id: storeId };
  //     base.category = "product";
  //   }

  //   // Get items from change/object
  //   const items = this.change?.items || this.object?.items || [];

  //   // ✅ If no items, fallback to saving as-is (optional)
  //   if (!Array.isArray(items) || items.length === 0) {
  //     const payload = { ...this.change, ...base };
  //     console.log("Payload Post (single): ", payload);
  //     await this.upsertUseCase.execute(collection, payload);
  //     this.change = {};
  //     return;
  //   }

  //   // ✅ Build one payload per item
  //   const payloads = items.map((it) => ({
  //     ...base,
  //     product: it.product || null, // keep pointer if you want
  //     name: it.itemName || it.name || "", // rename to "name"
  //     sku: it.sku || "",
  //     amount: String(it.cost ?? it.amount ?? 0), // rename to "amount"
  //     quantity: String(it.quantity ?? 0),
  //     description: it.description || "",
  //   }));

  //   console.log("Payloads Post (breakdown): ", payloads);

  //   // ✅ Save all (sequential)
  //   for (const payload of payloads) {
  //     console.log("Paypay", payload);
  //     // await this.upsertUseCase.execute(collection, payload);
  //   }

  //   // ✅ Clear change after save
  //   this.change = {};
  // }

  async deductOtherRawMaterials({ storeId, productSku, wasteQty, response }) {
    if (!storeId || !productSku || !wasteQty) return;
    console.log("WQWWW", productSku, storeId);
    // A) Find product (same sku + storeId)
    const products = await findObjectUseCase().execute("products", {
      where: {
        sku: String(productSku),
        // storeId: { id: storeId },
      },
      limit: 1,
      keys: ["id", "sku", "components", "others_raw_materials"],
    });

    console.log("pp", products);

    const product = Array.isArray(products) ? products[0] : null;
    const raws = product?.others_raw_materials || [];
    const coms = product?.components || [];
    console.log("coms", coms);

    if (!product || !Array.isArray(raws) || raws.length === 0) return;

    for (const com of coms) {
      const componentSku = com?.sku;
      const componentItemName = com?.itemName;
      const comPerItemQty = Number(com?.quantity ?? 0);

      if (!componentSku || comPerItemQty <= 0) continue;

      const deductQty = comPerItemQty * Number(wasteQty);

      console.log("deductQty", deductQty);

      // Find pofb row
      const pofbu = await findObjectUseCase().execute("inventory", {
        where: {
          sku: componentSku,
          storeId: { id: storeId },
        },
        include: ["component"],
        keys: [
          "id",
          "sku",
          "component",
          "storeId",
          "quantity",
          "itemName",
          "systemCount",
        ],
      });

      console.log("pofbu", pofbu);

      const pofbuObj = Array.isArray(pofbu) ? pofbu[0] : null;
      console.log("pofbuObj", pofbuObj);

      const current = Number(pofbuObj?.systemCount ?? 0);
      const nextQuantity = current - deductQty;

      console.log("current", current);
      console.log("nextQuantity", nextQuantity);

      console.log("Update POFB:", {
        id: pofbuObj?.id,
        quantity: nextQuantity,
      });

      // Update pofb row
      await this.upsertUseCase.execute("inventory", {
        id: pofbuObj?.id,
        systemCount: String(nextQuantity),
      });

      await this._saveReceivableTransaction({
        storeId: { id: storeId },
        sku: componentSku,
        item_name: componentItemName,
        transaction_type: "Waste",
        quantity: String(-deductQty),
        business_date: new Date().toISOString(),
        reference_id: response?.id,
      });

      // // Find pofb row
      // const pofbu = await findObjectUseCase().execute("backup_pullouts", {
      //   where: {
      //     component: { sku: componentSku },
      //     storeId: { id: storeId },
      //   },
      //   include: ["component"],
      //   keys: ["id", "sku", "component", "storeId", "quantity"],
      // });

      // console.log("pofbu", pofbu);

      // const pofbuObj = Array.isArray(pofbu) ? pofbu[0] : null;
      // console.log("pofbuObj", pofbuObj);

      // const current = Number(pofbuObj?.quantity ?? 0);
      // const nextQuantity = current - deductQty;

      // console.log("current", current);
      // console.log("nextQuantity", nextQuantity);

      // console.log("Update POFB:", {
      //   id: pofbuObj?.id,
      //   quantity: nextQuantity,
      // });

      // // Update pofb row
      // await this.upsertUseCase.execute("backup_pullouts", {
      //   id: pofbuObj?.id,
      //   quantity: String(nextQuantity),
      // });
    }

    // B) For each raw material, deduct from inventory.systemCount
    for (const rm of raws) {
      const rawSku = rm?.sku;
      const rawItemName = rm?.itemName;
      const perItemQty = Number(rm?.quantity ?? 0); // qty per 1 product

      if (!rawSku || perItemQty <= 0) continue;

      const deductQty = perItemQty * Number(wasteQty);

      // Find inventory row
      const invs = await findObjectUseCase().execute("inventory", {
        where: {
          sku: rawSku,
          storeId: { id: storeId },
        },
        limit: 1,
        keys: ["id", "sku", "systemCount", "storeId"],
      });

      const inv = Array.isArray(invs) ? invs[0] : null;
      if (!inv?.id) continue;

      const current = Number(inv.systemCount ?? 0);
      const nextSystemCount = current - deductQty;

      console.log("Update INV:", {
        id: inv.id,
        systemCount: nextSystemCount,
      });

      // Update inventory row
      await this.upsertUseCase.execute("inventory", {
        id: inv?.id,
        systemCount: String(nextSystemCount),
      });

      await this._saveReceivableTransaction({
        storeId: { id: storeId },
        sku: rawSku,
        item_name: rawItemName,
        transaction_type: "Waste",
        quantity: String(deductQty),
        business_date: new Date().toISOString(),
        reference_id: response?.id,
      });
    }
  }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const storeId = user?.storeAnalytic?.[0]?.id;

    const base = {};
    if (this.object?.id) {
      base.id = this.object.id;
    } else {
      base.acl = this.view.getAcl();
      base.storeId = { id: storeId };
      base.category = "product";
    }

    const items = this.change?.items || this.object?.items || [];

    // 1) Build one payload per item (breakdown)
    const payloads = (Array.isArray(items) ? items : []).map((it) => ({
      ...base,
      product: it.product || null,
      name: it.itemName || it.name || "",
      sku: it.sku || "",
      amount: String(it.cost ?? it.amount ?? 0),
      quantity: String(it.quantity ?? 0),
      description: it.description || "",
      wasteType: "Manual Waste" || "POS Waste",
      voidDate: new Date().toISOString(),
      isUpsale: false,
    }));

    console.log("Payloads Post (breakdown): ", payloads);

    try {
      // 2) Save each waste record
      for (const payload of payloads) {
        console.log("Pay", payload);
        delete payload.product;
        const response = await this.upsertUseCase.execute(collection, payload);

        // 3) After  save: deduct raw materials for this waste line
        await this.deductOtherRawMaterials({
          storeId,
          productSku: payload.sku,
          wasteQty: payload.quantity,
          response: response?.id,
        });
      }

      this.change = {};
      this.view.hideProgressDialog();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              dialog.close();
              this.view.navigateBack();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      throw error;
    }
  }

  async _saveReceivableTransaction(inventoryItem) {
    try {
      // const payload = {
      //   storeId: { id: storeId },
      //   sku: material.sku,
      //   item_name: material.itemName,
      //   transaction_type: "Direct Purchase",
      //   quantity: String(material.quantity),
      //   business_date: new Date().toISOString(),
      //   reference_id: directPurchaseResponse?.id,
      // };

      await this.upsertUseCase.execute("inventory_transaction", inventoryItem);
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();
      // this.view.submissionSuccess();
      // this.view.showSuccessSnackbar("Successfully saved!");
      // this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default WasteProductFormPresenter;
